module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0146.jpg?v=9739754c";